import axios from 'axios'

const anklePatrolAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
})

const username = 'ankle-patrol'
const password = 'ankle@V1'
const users = btoa(`${username}:${password}`)

anklePatrolAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    config.headers['users'] = `Basic ${users}`
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

anklePatrolAxios.interceptors.response.use(
  (response) => {
    // Response with 2xx status code lies here
    return response.data
  },
  async (error) => {
    const { response } = error

    if (response && response.status === 401) {
      localStorage.clear()
      window.location.replace('/')
    }
    return Promise.reject(error.response.data)
  },
)

export default anklePatrolAxios
